import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  IconButton,
  Select,
  Chip,
  Dialog,
  DialogContent,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import contries from "./Country.json";
import SelectField from "../../../Components/Masters/SelectField";
import { get, post, put } from "../../../utils/api";
import { useUser } from "../../../context/AuthContext";
import { validateNumber } from "../../../utils/validateFields";
import EmailField from "../../../Components/Masters/EmailField";
import PhoneInputField from "../../../Components/Masters/PhoneInputField";
import EditDialog from "../../../Components/Common/EditDialog";

const facilitymoduleName = [
  "Select All",
  "Environment | Scope 1 | Overview",
  "Environment | Scope 1 | Stationary Combustion",
  "Environment | Scope 1 | Mobile Combustion",
  "Environment | Scope 1 | Fugitive Emissions",
  "Environment | Scope 2 | Overview",
  "Environment | Scope 2 | Electricity",
  "Environment | Scope 2 | Heating / Cooling",
  "Environment | Scope 2 | Steam",
  "Environment | Scope 3 | Overview",
  "Environment | Scope 3 | Purchased goods & services",
  "Environment | Scope 3 | Transportation distribution",
  "Environment | Scope 3 | Employee commute",
  "Environment | Scope 3 | Business travel",
  "Environment | Scope 3 | Fuel and Energy-Related Activities",
  "Environment | Scope 3 | Waste generated",
  "Environment | Scope 3 | Captial Goods",
  "Environment | Scope 3 | Upstream Leased Assets",
  "Environment | Scope 3 | Downstream Leased Assets",
  "Environment | Scope 3 | Franchises",
  "Environment | Scope 3 | Investments",
  "Environment | Scope 3 | Processing of Sold Products",
  "Environment | Scope 3 | Use of Sold Products",
  "Environment | Scope 3 | End of Life Treatment of Sold Products",
  "Environment | Scope 4 | Carbon Avoidance | Renewable",
  "Environment | Scope 4 | Carbon Avoidance | LowerCarbonProduct",
  "Environment | Scope 4 | Carbon Offsetting | InHouseoffSet",
  "Environment | Scope 4 | Carbon Offsetting | OffsetCredit",
  "Production",
  "Setup | Masters",
  "Setup | Roles & Permission",
  "Water management",
  // "Value Chain | Partner",
  // "Value Chain | Request",
  // "Value Chain | Dashboard",
  "Documentation",
];
const groupmodulesName = [
  "Select All",
  "Environment | Scope 1 ",
  "Environment | Scope 2 ",
  "Environment | Scope 3 | Overview",
  "Environment | Scope 3 | Purchased goods & services",
  "Environment | Scope 3 | Transportation distribution",
  "Environment | Scope 3 | Employee commute",
  "Environment | Scope 3 | Business travel",
  "Environment | Scope 3 | Fuel and Energy-Related Activities",
  "Environment | Scope 3 | Waste generated",
  "Environment | Scope 3 | Captial Goods",
  "Environment | Scope 3 | Upstream Leased Assets",
  "Environment | Scope 3 | Downstream Leased Assets",
  "Environment | Scope 3 | Franchises",
  "Environment | Scope 3 | Investments",
  "Environment | Scope 3 | End of Life Treatment of Sold Products",
  "Environment | Scope 3 | Processing of Sold Products",
  "Environment | Scope 3 | Use of Sold Products",
  "Environment | Scope 4 | Carbon Avoidance | Renewable",
  "Environment | Scope 4 | Carbon Avoidance | LowerCarbonProduct",
  "Environment | Scope 4 | Carbon Offsetting | InHouseoffSet",
  "Environment | Scope 4 | Carbon Offsetting | OffsetCredit",
  "Water management",
  "Social",
  "MIS Reports",
  "GHG Reports",
  "Production & Revenue",
  "Governance",
  "Support",
  "Documentation",
  "FAQ",
  "Settings",
];
const moduleNames = [
  "Select All",
  "MIS Reports",
  "GHG Reports",
  "Environment | Scope 1 | Overview",
  "Environment | Scope 1 | Stationary Combustion",
  "Environment | Scope 1 | Mobile Combustion",
  "Environment | Scope 2 | Overview",
  "Environment | Scope 1 | Fugitive Emissions",
  "Environment | Scope 2 | Electricity",
  "Environment | Scope 2 | Heating / Cooling",
  "Environment | Scope 2 | Steam",
  "Environment | Scope 3 | Overview",
  "Environment | Scope 3 | Purchased goods & services",
  "Environment | Scope 3 | Transportation distribution",
  "Environment | Scope 3 | Employee commute",
  "Environment | Scope 3 | Business travel",
  "Environment | Scope 3 | Fuel and Energy-Related Activities",
  "Environment | Scope 3 | Waste generated",
  "Environment | Scope 3 | Captial Goods",
  "Environment | Scope 3 | Upstream Leased Assets",
  "Environment | Scope 3 | Downstream Leased Assets",
  "Environment | Scope 3 | Franchises",
  "Environment | Scope 3 | Investments",
  "Environment | Scope 3 | End of Life Treatment of Sold Products",
  "Environment | Scope 3 | Processing of Sold Products",
  "Environment | Scope 3 | Use of Sold Products",
  "Environment | Scope 4 | Carbon Avoidance | Renewable",
  "Environment | Scope 4 | Carbon Avoidance | LowerCarbonProduct",
  "Environment | Scope 4 | Carbon Offsetting | InHouseoffSet",
  "Environment | Scope 4 | Carbon Offsetting | OffsetCredit",
  "Water management",
  "Social",
  "Governance",
  "Production & Revenue",
  "ESG Reporting | BRSR",
  "ESG Reporting | GRI",
  "Value Chain | Partner",
  "Value Chain | Request",
  "Value Chain | Dashboard",
  "Setup | Masters",
  "Setup | Roles & Permission",
  "Setup | Facility Master",
  "Documentation",
];

const trialModuleNames = [
  "Select All",
  "Environment | Scope 1 | Overview",
  "Environment | Scope 1 | Stationary Combustion",
  "Environment | Scope 1 | Mobile Combustion",
  "Environment | Scope 1 | Fugitive Emissions",
  "Environment | Scope 2 | Overview",
  "Environment | Scope 2 | Electricity",
  "Environment | Scope 2 | Heating / Cooling",
  "Environment | Scope 2 | Steam",
  "Environment | Scope 3 | Overview",
  "Environment | Scope 3 | Purchased goods & services",
  "Environment | Scope 3 | Transportation distribution",
  "Setup | Masters",
  "Setup | Roles & Permission",
  "Setup | Facility Master",
];

function Add(props) {
  const { user } = useUser();
  const [facilities, setFacility] = useState(["Tap to Select"]);
  const [roles, setRole] = useState(["Tap to Select"]);
  const [updatedRoles, setUpdatedRoles] = useState(["Tap to Select"]);
  const [FunctionalityRole, setFunctinalityRole] = useState([]);
  const [alreadyUser, setAlreadyUser] = useState(false);
  const [selectedEmail, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [verify, setVerify] = useState({
    phone: false,
    mail: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [TaskAltIcons, setTaskAltIcons] = useState({
    email: false,
    phone: false,
  });
  const [ssoEnabled, setSsoEnabled] = useState(false);

  useEffect(() => {
    if (user?.company?.ssoEnabled) {
      setSsoEnabled(true);
    }
  }, [user]);
  // Time state
  const [otp, setOTP] = useState({
    phone: null,
    email: null,
  });

  const initialState = {
    userType: user?.companyAdmin === true ? "Company Admin" : "User",
    country: "",
    facility: user?.facility?._id,
    companyName: "",
    name: "",
    email: "",
    phone: "",
    role: ["Tap to Select"],
    countryOperation: "",
    countryCode: "",
    remark: "",
    modules: [],
  };

  const [fromValue, setFromValue] = useState(initialState);
  const [fromValue2, setFromValue2] = useState(initialState);
  const [validateUserType, setValidateUserType] = useState("User");
  const [editDialog, setEditDialog] = useState(false);
  const [ssoWarningOpen, setSsoWarningOpen] = useState(false);
  const [companyDomain, setCompanyDomain] = useState(
    user?.company?.email ? user?.company?.email.split("@")[1] : "",
  );
  useEffect(() => {
    if (user?.company?.email) {
      setCompanyDomain(user?.company?.email.split("@")[1]);
    }
  }, [user?.company?.email]);

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === fromValue2[key],
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    props.setValue(false);
    setEditDialog(false);
    setverifybtn({ phone: false, email: false });
    setVerify({ phone: false, email: false, emailMsg: "", phoneMsg: "" });
    setTaskAltIcons({ phone: false, email: false });
    setValidateUserType("User");
    resetForm();
    // }
  };
  const resetForm = () => {
    setTaskAltIcons({
      email: false,
      phone: false,
    });
    setOTP({
      phone: null,
      email: null,
    });
    setVerify({
      phone: false,
      mail: false,
    });
    setverifybtn({ email: false, phone: false });
    setEmail(props.index === 0 ? "" : props.index?.email);
    setState();
    setErrors({});
    setValidateUserType("User");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "forUpdate");
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    if (name === "userType") {
      setValidateUserType(value);
    }
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleChangeModule = (event) => {
    const value = event.target.value;
    const SelectedModules = user?.isTrialUser
      ? trialModuleNames
      : user?.facilityManger
        ? facilitymoduleName
        : user?.groupManager
          ? groupmodulesName
          : user?.endUser
            ? facilitymoduleName
            : moduleNames;
    // If "Select All" is chosen, select all or deselect all
    if (value.includes("Select All")) {
      setFromValue({
        ...fromValue,
        modules:
          fromValue.modules.length === SelectedModules.length - 1
            ? []
            : SelectedModules.slice(1),
      });
    } else {
      setFromValue({
        ...fromValue,
        modules: value,
      });
    }
    setErrors((prev) => ({ ...prev, moduleName: "" }));
  };

  useEffect(() => {
    const fetchData = async (url) => {
      try {
        const response = await get(url);
        return response;
      } catch (err) {
        console.error(`Error fetching data from ${url}:`, err);
      }
    };

    fetchData(`/auth/FetchUserRoles`).then((res) => {
      if (res) {
        console.log(res.data.data, "datafacility");
        setFunctinalityRole(res.data.data);
        setRole(res.data.data);
      }
    });

    fetchData(`/master/getAllFacility`).then((res) => {
      if (res) {
        console.log(res.data.data, "resfacility");
        setFacility(res.data.data);
      }
    });
  }, [props.index]);

  useEffect(() => {
    console.log(roles, user, "roles");
    let filteredRoles = roles.filter(
      (role) =>
        role?.facility ===
        (user?.companyAdmin ? fromValue?.facility : user?.facility?._id),
    );
    setUpdatedRoles(filteredRoles);
  }, [fromValue?.facility, roles]);

  const setState = () => {
    if (props.index !== 0) {
      // Get country for Company Admin users
      let userCountry = props.index?.country;
      if (!userCountry && props.index?.companyAdmin) {
        // Try to get country from company admin or company
        // Priority: company.country > company.admin.countryCode (extract) > countryCode (extract)
        if (props.index?.company?.country) {
          userCountry = props.index.company.country;
        } else if (props.index?.company?.admin?.countryCode) {
          const parts = props.index.company.admin.countryCode.split(" - ");
          userCountry = parts.length > 1 ? parts[1] : "Select Country";
        } else if (props.index?.countryCode) {
          const parts = props.index.countryCode.split(" - ");
          userCountry = parts.length > 1 ? parts[1] : "Select Country";
        } else {
          userCountry = "Select Country";
        }
      }

      // Get countryCode (dial_code) for Company Admin users
      let userCountryCode = props.index?.countryCode;
      if (!userCountryCode && props.index?.companyAdmin) {
        // Extract dial_code from format "+91 - India" -> "+91"
        if (props.index?.company?.admin?.countryCode) {
          const parts = props.index.company.admin.countryCode.split(" - ");
          userCountryCode = parts.length > 0 ? parts[0] : "";
        } else if (props.index?.company?.countryCode) {
          const parts = props.index.company.countryCode.split(" - ");
          userCountryCode = parts.length > 0 ? parts[0] : "";
        } else {
          userCountryCode = "";
        }
      } else if (userCountryCode && userCountryCode.includes(" - ")) {
        // If countryCode is in format "+91 - India", extract just the dial_code
        const parts = userCountryCode.split(" - ");
        userCountryCode = parts.length > 0 ? parts[0] : "";
      }

      const state = {
        userType: user?.companyAdmin === true ? "Company Admin" : "User",
        companyName: user?.company?.companyName ?? "",
        countryOperation: user?.company?.headquarters ?? "",
        country: userCountry || "Select Country",
        facility: props.index?.facility?._id ?? "",
        email: props.index?.email ?? "",
        name: props.index?.name ?? "",
        phone: props.index?.phone ?? "",
        role: props.index?.role?._id ?? "",
        countryCode: userCountryCode || "",
        remark: props.index?.remark ?? "",
        modules: props.index?.modules ?? [],
      };
      setFromValue(state);
      setFromValue2(state);
      setEmail(props.index?.email);
      setAlreadyUser(true);
      setTaskAltIcons({ ...TaskAltIcons, email: true });
    } else {
      const state = {
        userType: user?.companyAdmin === true ? "Company Admin" : "User",
        companyName: user?.company?.companyName ?? "",
        countryOperation: user?.company?.headquarters ?? "",
        country: "",
        facility: user?.facility?._id,
        email: "",
        name: "",
        phone: "",
        role: ["Tap to Select"],
        countryCode: "",
        remark: "",
        modules: [],
      };
      setFromValue(state);
      setFromValue2(state);
      setTaskAltIcons({ ...TaskAltIcons, email: false });

      setEmail("");
      setAlreadyUser(false);
    }
  };

  useEffect(() => {
    setState();
  }, [props.index, FunctionalityRole, companyDomain]); // Add necessary dependencies

  const handleSubmitClick = () => {
    if (!validateForm()) return;
    if (ssoEnabled && companyDomain !== fromValue?.email?.split("@")[1]) {
      setSsoWarningOpen(true);
      return;
    }
    Submit();
  };

  const handleSsoWarningConfirm = () => {
    setSsoWarningOpen(false);
    Submit();
  };

  const Submit = async () => {
    const keysToRemove = [
      "role",
      "createdBy",
      "remark",
      "facility",
      "countryOperation",
      // "modules",
    ];
    const keysToRemoveGroupAdmin = [
      "createdBy",
      "facility",
      "countryOperation",
      "userType",
      "companyName",
      "role",
    ];

    // const data = Object.fromEntries(
    //   Object.entries(fromValue).filter(
    //     ([key, value]) =>
    //       !(
    //         keysToRemove.includes(key) &&
    //         (value === "" || value === "undefined" || value === null )
    //       )
    //   )
    // );
    const data = {
      ...fromValue,
    };
    if (fromValue?.userType === "Company Admin") {
      keysToRemove.forEach((key) => {
        delete data[key];
      });
    }
    if (user?.groupManager) {
      keysToRemoveGroupAdmin.forEach((key) => {
        delete data[key];
      });
    }
    if (user?.groupManager) {
      keysToRemoveGroupAdmin.forEach((key) => {
        delete data[key];
      });
    }
    try {
      const url = alreadyUser
        ? `/auth/updateUser?Id=${props.index?._id}`
        : `/auth/createUser`;

      const method = alreadyUser ? put : post;
      const response = await method(url, data);

      props.setValue(false);
      props.fetchUsers();
      resetForm();
      props.setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
    } catch (err) {
      if (err?.response?.data?.message === "Email Already exists.") {
        setErrors({ ...errors, email: err?.response?.data?.message });
      } else {
        props.setsnackOpen({
          open: true,
          message:
            err?.response?.data?.message ||
            err?.response?.data?.errors?.[0]?.msg ||
            "An error occurred",
          severity: "error",
        });
      }
    }
  };

  console.log("first123", fromValue, errors, props);

  const validateForm = () => {
    const newErrors = {};
    const {
      userType,
      companyName,
      country,
      facility,
      name,
      email,
      phone,
      role,
      countryCode,
      countryOperation,
      modules,
    } = fromValue;

    // Validate `company`
    if ((!companyName || companyName.trim() === "") && !user?.groupManager) {
      newErrors.companyName = "Company is required.";
    }
    if (!userType || userType.trim() === "") {
      newErrors.userType = "User Type is required.";
    }
    // if (
    //   (!countryOperation || countryOperation.trim() === "") &&
    //   userType === "User" &&
    //   !user?.groupManager
    // ) {
    //   newErrors.countryOperation = "Location is required.";
    // }

    // Validate `country`
    if (!country || country === "Tap to select") {
      newErrors.country = "Please select a country.";
    }

    if (modules?.length === 0 && userType === "User")
      if (!user.companyAdmin) {
        newErrors.moduleName = "Module Name is required.";
      }

    // Validate `facility`

    if (userType === "User" && !user?.groupManager && !fromValue.facility) {
      console.log("first23", fromValue);
      newErrors.facility = "Facility is required.";
    }

    // Validate `name`
    if (!name || name.trim() === "") {
      newErrors.name = "Name is required.";
    }

    // Validate `email`
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "A valid email is required.";
    }

    if (verifybtn.email === true && email) {
      newErrors.email = "Please validate your email.";
    }

    if (verifybtn.email === true && !otp.email) {
      newErrors.OTPemail = "Please enter the OTP";
    }

    console.log(typeof phone, "p11", phone);
    // Validate `phone` and `countryCode`
    if (phone) {
      // If phone number is present but countryCode is missing
      if (!validateNumber(phone) || phone?.length < 7) {
        newErrors.phone = "Please enter valid Mobile Number"; // Validates phone number format
      }
    }

    if (phone === "") newErrors.phone = `Mobile No. is required`;
    // if (!validateNumber(phone) || phone.length !== 10)
    //   newErrors.phone = "Please enter 10 digit Mobile Number";
    // Set the error message for mobileNo
    // else if (errors.phone) return;
    // else if (verify.phone) {
    //   setVerify({
    //     ...verify,
    //     phoneMsg: verify.phoneMsg || "OTP is required",
    //   });
    //   newErrors["mblOtp"] = "OTP is required";
    // } else if (!TaskAltIcons.phone)
    //   newErrors["phone"] =
    //     errors.phone || "Contact Number Verification required"; // Set the error message for mobileNo

    if (email === "") newErrors["email"] = `Email is required`;
    // else if (errors.email) return;
    if (verify.email) {
      newErrors["emailOtp"] = "OTP is required";
      setVerify({
        ...verify,
        phoneMsg: verify.phoneMsg || "OTP is required",
        emailMsg: verify.emailMsg || "OTP is required",
      });
    } else if (email && !TaskAltIcons.email)
      newErrors[email] = "Email Verification required";

    if (verifybtn.phone === true && verifybtn.phone === true && !otp.phone) {
      newErrors.OTPphone = "Please enter the OTP";
    }

    if (
      props.index?.facilityManger !== true &&
      !modules.length &&
      userType === "User"
    ) {
      newErrors.modules = "Modules are required.";
    }

    console.log(role, roles, "roleForTheData");
    // Validate `role`
    if (
      props.index?.facilityManger !== true &&
      userType === "User" &&
      !user?.groupManager &&
      (!role || role.length === 0 || role[0] === "Tap to Select")
    ) {
      newErrors.role = "Role is required.";
    }
    console.log(newErrors, "getting errors");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    if (name === "role") {
      setFromValue((prevFromValue) => ({
        ...prevFromValue,
        role: value,
      }));
    } else if (name === "facility") {
      setFromValue((prevFromValue) => ({
        ...prevFromValue,
        facility: name === "facility" ? value : prevFromValue.facility,
      }));
    }
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCountryChange = (event) => {
    console.log("event.target.value", event.target.value);
    const selectedCountryCode = event.target.value;
    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode,
    ); // Find the selected country object

    if (selectedCountry) {
      setFromValue({
        ...fromValue,
        country: selectedCountry.name, // Set country name
        countryCode: selectedCountry.dial_code, // Set country code
        phone: "",
      });

      setErrors((prev) => ({ ...prev, country: "" }));

      if (errors.phone === "Please Select Country")
        setErrors({ ...errors, phone: "" });

      if (selectedCountry.dial_code && fromValue.phone !== "") {
        console.log(fromValue.phone, "fromValue.phone");
        setVerify({ ...verify, phone: true });
        setErrors({ ...errors, phone: "" });
      }
    }
  };

  const list = (anchor) => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.6rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Dialog
        open={ssoWarningOpen}
        onClose={() => setSsoWarningOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "2rem",
            width: "25vw",
            textAlign: "center",
            position: "relative",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => setSsoWarningOpen(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#666",
          }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: "2rem",
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ErrorOutlineIcon sx={{ color: "#FFD5D0", fontSize: 48 }} />
            </Box>
          </Box>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "18px",
              lineHeight: "140%",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            Microsoft Login is not enabled for this domain
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              textAlign: "center",
              marginBottom: "1.5rem",
            }}
          >
            An email invitation and password setup link will be sent instead.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSsoWarningConfirm}
            sx={{
              backgroundColor: "#1C486B",
              borderRadius: "4px",
              textTransform: "none",
              fontWeight: 600,
              padding: "0.75rem",
            }}
          >
            Got it
          </Button>
        </DialogContent>
      </Dialog>

      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {props.index !== 0 ? "Edit User" : "Add User"}
        </Typography>
        {!user?.groupManager && (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              User Type
            </Typography>
            <CustomTextField
              // select
              variant="outlined"
              value={user?.companyAdmin ? "Management" : "Operational"}
              // onChange={handleDropdownChange}
              fullWidth
              name="userType"
              placeholder="Prefilled"
              error={!!errors.userType}
              InputLabelProps={{
                style: { color: errors.userType ? "#D34040" : undefined },
              }}
              InputProps={{
                readOnly: true,
              }}
              disable={true}
            />
          </>
        )}

        <SelectField
          title={"Country"}
          name={"country"}
          value={fromValue.country}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors["country"]}
          //   url={el.url}
        />
        {!user?.groupManager && (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Company Name
            </Typography>
            <CustomTextField
              variant="outlined"
              value={fromValue.companyName}
              fullWidth
              name="companyName"
              placeholder="Prefilled"
              InputProps={{
                readOnly: true, // Makes the field read-only
              }}
              error={!!errors.companyName} // Show error styling if there's an error
              InputLabelProps={{
                style: { color: errors.companyName ? "#D34040" : undefined },
              }}
            />
            {errors.companyName && (
              <Typography variant="body2" color="#D34040">
                {errors.companyName}
              </Typography>
            )}
          </>
        )}

        {/* {user?.companyAdmin && validateUserType === "User" && (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Facility
            </Typography>
            <CustomTextField
              select
              variant="outlined"
              value={fromValue.facility || "Tap to Select"}
              onChange={handleDropdownChange}
              fullWidth
              name="facility"
              placeholder="Tap to Select"
              error={!!errors.facility}
              InputLabelProps={{
                style: { color: errors.facility ? "#D34040" : undefined },
              }}
            >
              <MenuItem value="Tap to Select" disabled>
                Tap to Select
              </MenuItem>
              {facilities.map((item, i) => (
                <MenuItem key={i} value={item?._id}>
                  {item.facilityName}
                </MenuItem>
              ))}
            </CustomTextField>

            {errors.facility && (
              <Typography variant="body2" color="#D34040">
                {errors.facility}
              </Typography>
            )}
          </>
        )} */}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Employee Name
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.name}
          onChange={handleChange}
          fullWidth
          name="name"
          placeholder="Enter Name"
          error={!!errors.name}
          InputLabelProps={{
            style: { color: errors.name ? "#D34040" : undefined },
          }}
        />
        {errors.name && (
          <Typography variant="body2" color="#D34040">
            {errors.name}
          </Typography>
        )}
        {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Company Email
        </Typography>
        <Box
          sx={{
            display: `${TaskAltIcons.email === true ? "flex" : "block"}`,
            width: `${TaskAltIcons.email === true ? "100%" : "100%"}`,
          }}
        >
          <CustomTextField
            variant="outlined"
            value={selectedEmail}
            onChange={handleEmailChange}
            fullWidth
            name="email"
            placeholder="Enter Email"
            error={!!errors.email} // Show error styling if there's an error
            InputLabelProps={{
              style: { color: errors.email ? "#D34040" : undefined },
            }}
            InputProps={{
              endAdornment: TaskAltIcons.email && (
                <TaskAltIcon sx={{ color: "green", textAlign: "right" }} />
              ),
            }}
          />
        </Box>
        {errors.email && (
          <Typography variant="body2" color="#D34040">
            {errors.email}
          </Typography>
        )}
        {verifybtn.email && (
          <Box
            sx={{
              fontSize: "14px",
              color: "green",
              textDecoration: "underline",
              textAlign: "right",
              cursor: "pointer",
            }}
            onClick={() => handleVerifyEmail(120)}
          >
            Verify
          </Box>
        )}
        {verify.email && (
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Enter OTP For Email
            </Typography>

            <CustomTextField
              variant="outlined"
              value={otp.email}
              onChange={handleOTPVerify}
              fullWidth
              name="otpEmail"
              placeholder="Enter OTP"
              inputProps={{
                maxLength: 4,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              error={!!errors.OTPemail} // Show error styling if there's an error
              InputLabelProps={{
                style: { color: errors.OTPemail ? "#D34040" : undefined },
              }}
            />
            <Typography variant="body2" color="#D34040">
              {errors.OTPemail}
            </Typography>
            {time > 0 ? (
              <Box sx={{ textAlign: "right" }}>{formatTime(time)}</Box>
            ) : (
              <Box
                sx={{
                  fontSize: "14px",
                  color: "green",
                  textDecoration: "underline",
                  textAlign: "right",
                  cursor: "pointer",
                }}
                onClick={() => handleResend()}
              >
                Resend
              </Box>
            )}
          </Box>
        )} */}
        <EmailField
          title={"Email ID"}
          // handleChange={handleEmailChange}
          placeholder="Enter Email"
          value={fromValue?.email || ""}
          errors={errors["email"]}
          fieldName={"email"}
          showIcon={TaskAltIcons?.email === true}
          {...{
            setTaskAltIcons,
            TaskAltIcons,
            setErrors,
            setFormData: setFromValue,
            element: props?.index,
            formData: fromValue,
            setVerify,
            verify,
            setverifybtn,
            verifybtn,
          }}
        />

        {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Mobile No.
        </Typography>
        <Box
          sx={{
            display: `${TaskAltIcons.phone === true ? "flex" : "block"}`,
            width: `${TaskAltIcons.phone === true ? "100%" : "100%"}`,
          }}
        >
          <CustomTextField
            variant="outlined"
            value={fromValue.phone}
            onChange={handlePhoneChange}
            fullWidth
            name="phone"
            placeholder="Type Here"
            InputProps={{
              endAdornment: TaskAltIcons.phone && (
                <TaskAltIcon sx={{ color: "green", textAlign: "right" }} />
              ),
              startAdornment: (
                <InputAdornment position="start" sx={{ marginRight: "10px" }}>
                  <span style={{ marginLeft: "8px" }}>
                    {fromValue.countryCode}
                  </span>
                  <div
                    style={{
                      borderLeft: "1px solid #000",
                      height: "24px",
                      marginRight: "8px",
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {errors.phone && (
          <Typography variant="body2" color="#D34040">
            {errors.phone}
          </Typography>
        )}
        {verifybtn.phone && (
          <Box
            onClick={() => handleVerifyPhone(180)}
            sx={{
              fontSize: "14px",
              color: "green",
              textDecoration: "underline",
              textAlign: "right",
              cursor: "pointer",
            }}
          >
            Verify
          </Box>
        )}
        {verify.phone && (
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Enter OTP For Phone
            </Typography>
            <CustomTextField
              variant="outlined"
              value={otp.phone}
              onChange={handleOTPVerifyPhone}
              fullWidth
              name="otpPhone"
              placeholder="Enter OTP"
              inputProps={{
                maxLength: 4,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              error={!!errors.OTPphone} // Show error styling if there's an error
              InputLabelProps={{
                style: { color: errors.OTPphone ? "#D34040" : undefined },
              }}
            />
            <Typography variant="body2" color="#D34040">
              {errors.OTPphone}
            </Typography>
            {timerPhone > 0 ? (
              <Box sx={{ textAlign: "right" }}>{formatTime(timerPhone)}</Box>
            ) : (
              <Box
                sx={{
                  fontSize: "14px",
                  color: "green",
                  textDecoration: "underline",
                  textAlign: "right",
                  cursor: "pointer",
                }}
                onClick={() => handleResendPhone()}
              >
                Resend
              </Box>
            )}
          </Box>
          
        )} */}
        <PhoneInputField
          value={fromValue?.phone || ""} // Use optional chaining
          errors={errors["phone"]}
          fieldName={"phone"}
          placeholder="Enter Mobile No"
          title="Mobile No."
          {...{
            setErrors,
            setFormData: setFromValue,
            formData: fromValue,
          }}
          countryCode={fromValue?.countryCode || ""} // Use optional chaining
        />

        {validateUserType === "User" && !user?.groupManager ? (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Company Headquarters Location
            </Typography>
            <CustomTextField
              variant="outlined"
              // select
              value={fromValue.countryOperation}
              // onChange={handleCountryChange}
              fullWidth
              name="countryOperation"
              placeholder="Prefilled"
              InputProps={{
                readOnly: true, // Makes the field read-only
              }}
              error={!!errors.countryOperation} // Show error styling if there's an error
              InputLabelProps={{
                style: {
                  color: errors.countryOperation ? "#D34040" : undefined,
                },
              }}
            />
            {errors.countryOperation && (
              <Typography variant="body2" color="#D34040">
                {errors.countryOperation}
              </Typography>
            )}
          </>
        ) : null}

        {props.index?.facilityManger !== true &&
          props?.index?.companyAdmin !== true &&
          validateUserType === "User" &&
          !user?.companyAdmin &&
          !user?.groupManager && (
            <>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 1 }}
              >
                Assign Role
              </Typography>
              <CustomTextField
                select
                variant="outlined"
                value={fromValue.role}
                onChange={handleDropdownChange}
                fullWidth
                name="role"
                placeholder="Tap to Select"
                error={!!errors.role} // Show error styling if there's an error
                InputLabelProps={{
                  style: { color: errors.role ? "#D34040" : undefined },
                }}
              >
                <MenuItem
                  value={
                    fromValue.role === "" ? "Tap to Select" : fromValue.role
                  }
                  disabled
                >
                  Tap to Select
                </MenuItem>
                {updatedRoles.map((item, i) => (
                  <MenuItem key={i} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
              </CustomTextField>
              {errors.role && (
                <Typography variant="body2" color="#D34040">
                  {errors.role}
                </Typography>
              )}
            </>
          )}

        {props.index?.facilityManger !== true &&
          // props?.index?.companyAdmin !== true &&
          validateUserType === "User" && (
            <>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 1 }}
              >
                Module's Name
              </Typography>
              <Select
                multiple
                fullWidth
                size="small"
                style={{ marginBottom: "10px" }}
                value={fromValue.modules}
                onChange={handleChangeModule}
                displayEmpty
                renderValue={(selected) =>
                  selected.length === 0 ? "Tap to Select" : selected.join(", ")
                }
              >
                <MenuItem value="" disabled>
                  Tap to Select
                </MenuItem>

                {(user?.isTrialUser
                  ? trialModuleNames
                  : user?.facilityManger
                    ? facilitymoduleName
                    : user?.groupManager
                      ? groupmodulesName
                      : user?.endUser
                        ? facilitymoduleName
                        : moduleNames
                )?.map((module) => (
                  <MenuItem key={module} value={module}>
                    {module}
                  </MenuItem>
                ))}
              </Select>

              {fromValue?.modules?.map((value) => (
                <Chip
                  key={value}
                  label={value}
                  sx={{
                    bgcolor: "#1C486B",
                    color: "white",
                    height: "28px",
                    m: 0.25,
                    "& .MuiChip-deleteIcon": {
                      color: "white",
                      "&:hover": {
                        color: "white",
                      },
                    },
                  }}
                  onDelete={() =>
                    handleChangeModule({
                      target: {
                        value: fromValue?.modules?.filter((v) => v !== value),
                      },
                    })
                  }
                />
              ))}

              {errors.moduleName && (
                <Typography
                  variant="body2"
                  color="#D34040"
                  sx={{ mt: "-0.5rem" }}
                >
                  {errors.moduleName}
                </Typography>
              )}
            </>
          )}

        {validateUserType === "User" ? (
          <>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Remark
            </Typography>
            <TextField
              rows={2}
              variant="outlined"
              value={fromValue.remark}
              onChange={handleChange}
              fullWidth
              name="remark"
              placeholder="Brief"
              multiline
            ></TextField>
          </>
        ) : null}

        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={handleSubmitClick}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          width: "100%",
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.value}
        onClose={handleClose}
      >
        {list()}
      </Drawer>
    </div>
  );
}
export default Add;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
}));
